module.exports = __webpack_public_path__ + "static/media/logo-small.70539639.png";